<form class="sgt-usuario-permissao-campanha" #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Campanhas
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso no lançamento das Campanhas</small>
        </div>
        
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeAnalisarCampanhas" name="podeAnalisarCampanhas" id="podeAnalisarCampanhas">
                    <label class="custom-control-label" for="podeAnalisarCampanhas">Analisar Campanhas</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário aprovar e reprovar campanhas</p>
            </li>
        </ul>                               
    </div>
</form>